<template>
  <n-modal v-bind="$props">
    <Form ref="modalForm" :model="model" :label-width="labelWidth" class="n-modal-container" @submit.native.prevent>
      <n-row-col2>
        <!-- id -->
        <!-- prettier-ignore -->
        <n-field-id v-model="model.id" field-name="id" label="id" :error="error.id" :disabled="isEdit || disabled" />
        <!-- name -->
        <!-- prettier-ignore -->
        <n-field-text v-model="model.name" field-name="name" label="name" :error="error.name" :disabled="disabled" />
      </n-row-col2>
      <n-row-col2>
        <!-- type -->
        <!-- prettier-ignore -->
        <n-field-enum v-model="model.type" field-name="type" enum-name="CurrencyType" :error="error.type" label="type" :disabled="isEdit || disabled" />
        <!-- code -->
        <!-- prettier-ignore -->
        <n-field-text v-model="model.code" field-name="code" label="code" :error="error.code" :disabled="disabled" />
      </n-row-col2>
      <n-row-col2>
        <!-- scale -->
        <!-- prettier-ignore -->
        <n-field-number v-model="model.scale" field-name="scale" label="scale" :error="error.scale" :disabled="isEdit || disabled" />
        <!-- unit -->
        <!-- prettier-ignore -->
        <n-field-text v-model="model.unit" field-name="unit" :error="error.unit" label="unit" :disabled="disabled" />
      </n-row-col2>
      <n-row-col2>
        <!-- version -->
        <n-field-decimal v-model="model.rate" field-name="rate" label="rate" :error="error.rate" :disabled="disabled" />
        <!-- image -->
        <!-- prettier-ignore -->
        <n-field-number v-model="model.image" field-name="image" label="image" :error="error.image" :disabled="disabled" />
      </n-row-col2>
    </Form>
  </n-modal>
</template>
<script>
import NModal from '@/components/common/NModal';
import { validate, edit } from '@/api/market/market-currency';

export default NModal.extend({
  name: 'ModalCurrency',
  components: { NModal },

  methods: {
    doSubmit(model) {
      return edit(model);
    },

    doValidate(model) {
      return validate(model);
    },
  },
});
</script>
